'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.JsonTransportMiddleware = JsonTransportMiddleware;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let http204 = 204;
function* JsonTransportMiddleware(_ref, next) {
    let request = _ref.request,
        response = _ref.response;

    request.headers.accept = 'application/json';
    if (request.body) {
        request.headers['content-type'] = 'application/json';
        request.body = (0, _stringify2.default)(request.body);
    }
    yield* next();
    if (response.statusCode === http204) {} else {
        if (/^application\/json/.test(response.headers['content-type'])) {
            if (typeof response.body !== 'object' && response.body !== undefined) {
                response.body = JSON.parse(response.body);
            }
        }
    }
}
//# sourceMappingURL=JsonTransportMiddleware.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/middlewares/JsonTransportMiddleware.js